<template>
  <main class="min-h-full flex-1"><div class="min-h-full py-6">
    <div class="mx-auto min-h-full px-4 sm:px-6 md:px-8">
      <!--v-if-->
      <div class="rounded-md rounded-t-md border border-gray-100 bg-gray-50 shadow-md">
        <form @submit.prevent="submit">
        <div class="border-b border-gray-200">
          <div class="w-full px-4 pt-4 pb-5 sm:flex sm:items-center sm:justify-between">
            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ product.name }}</h3>
            <div class="flex items-center"><div class="mt-3 flex space-x-4 sm:mt-0 sm:ml-4">
              <button class="inline-flex w-full justify-center rounded-md border border-transparent px-4 py-2 text-base font-medium text-white shadow-sm sm:col-start-2 sm:text-sm  bg-green-600 hover:bg-green-700 text-white   focus:ring-green-500  focus:outline-none focus:ring-2 focus:ring-offset-2 cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
                      type="submit">
                Bewaar
              </button>
              <button class="bg-red-600 hover:bg-red-700 text-white cursor-pointer rounded-md px-4 py-2 text-sm font-medium text-white shadow-sm"
                      type="submit"
              >
                Verwijder
              </button>
            </div>
            </div>
          </div>
        </div>
        <div class="rounded-b-md bg-white p-4">
          <!--v-if-->
          <div class="flex flex-wrap">
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Naam</label>
              <div class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.name }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>EAN</label>
              <div class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.ean }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Hope</label>
              <div class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.hope }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Leverancier</label>
              <div class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.supplier }}
              </div>
              <!--v-if--></div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Afdeling</label>
              <div class="block h-10 w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.aisle }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Officiële Prijs</label>
              <div class="block w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.official_price }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Upsell Prijs</label>
              <div class="block w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.upsell_price }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4" form="[object Object]">
              <label>Lokale Prijs</label>
              <div class="block w-full rounded-md border-gray-300 bg-white p-2 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
                {{ product.local_price }}
              </div>
              <!--v-if-->
            </div>
            <div class="w-1/2 py-2 px-4 flex items-center justify-start" form="[object Object]" data-v-018ef700="">
              <!--v-if-->
              <div class="switch ml-2" data-v-018ef700="">
                <ToggleSwitch :value="product.active" @toggleStatus="toggleStatus"/>
              </div>
              <label class="ml-4">Actief</label>
            </div>
          </div>
        </div>
        </form>
        <div class="mx-4 mt-3">
          <PriceCalendar :entity="product" :store="selectedStore" @changed="changeStoreIndex"/>
        </div>

        <div v-if="selectedStore">
          <PriceHistoryChart :entity="props.product" :store="selectedStore"></PriceHistoryChart>
        </div>
      </div>
    </div>
  </div>
  </main>
</template>

<script setup>
import ToggleSwitch from "@common/Form/ToggleSwitch";
import PriceCalendar from "@bread/ui/Components/PriceCalendar";
import PriceHistoryChart from "@bread/ui/Components/PriceHistoryChart";
import {reactive, ref} from 'vue';
import {computed} from "vue";
import {Inertia} from "@inertiajs/inertia";

const props = defineProps({
  product : {
    type : Object,
    required : true,
  },
  stores : {
    type : Object,
    required : true,
  }
  })

const selectedStoreIndex = ref('0');

const changeStoreIndex = (index ) => {
  console.log(index);
  selectedStoreIndex.value = index;
};

const selectedStore = computed(() => {
  return props.stores ? props.stores[selectedStoreIndex.value] : [{dates : []}];
});

const submit = ()=> {
  Inertia.put('/admin/products/'+props.product.id ,props.product)
}

const toggleStatus = () => {
  props.product.active = !props.product.active;
  Inertia.put('/admin/products/'+props.product.id,
    {
      storeId : props.stores[selectedStoreIndex.value].id,
      active : props.product.active,
    })
}
</script>

<style scoped>

</style>
